import { render, staticRenderFns } from "./configuracionAgenda.vue?vue&type=template&id=0e451794&scoped=true"
import script from "./configuracionAgenda.vue?vue&type=script&lang=js"
export * from "./configuracionAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e451794",
  null
  
)

export default component.exports